import type { FC } from "react";
import {
	ClientPortfolioToolIdentificationTypeEnum,
	ClientPortfolioToolTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type { ProducerInstrumentRowProps } from "web_myplann/Portfolio/Helpers/investmentToolTypes";
import { DataRow } from "web_myplann/Shared/Components/DataRow";
import { moneyFormatter } from "web_myplann/Shared/Utils/formatters";
import { ToolRowWrapper } from "./ToolRowWrapper";

const PageResources = Resources.PortfolioDetail;

export const ProducerInstrumentToolRow: FC<ProducerInstrumentRowProps> = ({
	producerInstrument,
	instrumentIdx,
	portfolioId,
	currencySign,
	expanded,
	onToggle,
	noDivider,
}) => {
	const { t } = useResource();

	const totalValue = moneyFormatter(
		producerInstrument.currentValue ?? 0,
		currencySign,
		undefined,
		0,
	);

	return (
		<ToolRowWrapper
			label={producerInstrument.name ?? ""}
			totalValue={totalValue}
			expanded={expanded}
			onToggle={onToggle}
			noDivider={noDivider}
			portfolioId={portfolioId}
			toolIdx={instrumentIdx}
		>
			<DataRow
				label={t(PageResources.LifeInsurance.InvestmentTool.type)}
				value={t(
					PageResources.LifeInsurance.InvestmentTool.Type[
						producerInstrument.type ?? ClientPortfolioToolTypeEnum.Other
					],
				)}
			/>
			<DataRow
				label={t(
					PageResources.LifeInsurance.InvestmentTool.IdentificationType[
						ClientPortfolioToolIdentificationTypeEnum.Isin
					],
				)}
				value={producerInstrument.isin}
			/>
			<DataRow
				label={t(PageResources.ToolHistory.BankProducts.currentValue)}
				value={totalValue}
			/>
		</ToolRowWrapper>
	);
};
